export const firebaseConfig = {
	apiKey:        'AIzaSyATvyE6NsfsxxVw7az_Gqeg9t3pb6ICHEs',
	authDomain:    'forty-4eb4c.firebaseapp.com',
	databaseUrl:   'https://forty-4eb4c.firebaseio.com',
	storageBucket: 'forty-4eb4c.appspot.com',
}

export const flamelinkConfig = {
	apiKey:        'AIzaSyAuQ8VWANp4FB6sqbQkbMAl8u-YHSJcdXQ',
	authDomain:    'forty-content.firebaseapp.com',
	databaseURL:   'https://forty-content.firebaseio.com',
	projectId:     'forty-content',
	storageBucket: 'forty-content.appspot.com',
}

export const contentfulConfig = {
	space:       'fnk1ahrdwdz5',
	accessToken: '063951d834f8b2b1f57a45f12347b07140a9daa549ba44cfe7f36cba528cb2ed',
}



// WEBPACK FOOTER //
// ./src/common/config/index.js